export default function(params) {
  const self = this;
  console.log('VideoVM initialized', params);

  self.id = params['id'];
  self.node = params['node'].querySelector('.js-video-player');
  self.src = params['src'];
  self.mediaUrls = {
    h264_360_url: params['h264_360_url'],
    h264_720_url: params['h264_720_url']
  };

  self.init = () => {
    self.player = new Kadenze.VideoPlayer($(self.node), self.mediaUrls, 'vjs-student-skin', null, null, {displayMode: 'gallery'});
    self.player.addEventListener('loadedData', function() {
      $(window).trigger('resize');
    });
    return self.player;
  };

  self.pause = function () {
    self.player && self.player.pause();
  };

  self.init();

  return self;
}

